import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RelatedSections = ({ items }) => {
  const { t } = useTranslation();
  if (!items || items.length === 0) return null;

  return (
    <div className="RelatedSections" aria-label={t('nav.relatedSectionsLabel')}>
      <span className="RelatedSections-label">{t('nav.relatedSectionsLabel')}:</span>
      <div className="RelatedSections-links RelatedSections-links--floating">
        {items.map(({ to, labelKey, Icon }, index) => {
          const label = t(labelKey);
          return (
            <Link
              key={to}
              to={to}
              className="RelatedSections-link RelatedSections-link--floating"
              style={{ '--related-index': index }}
              data-tooltip={label}
              aria-label={label}
            >
              {Icon && (
                <span className="RelatedSections-icon" aria-hidden="true">
                  <Icon />
                </span>
              )}
              <span className="RelatedSections-linkText">{label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RelatedSections;
